import { Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify.js"
import { COLOR_FROM_CLASSIFICATION, ICON_FROM_CLASSIFICATION } from "library/SFG20/constants.mjs"

export function AssetMappingCriticalityIcons({ item: [type, count] }) {
    return (
        <Stack direction="row" alignItems="center" spacing={0.4}>
            <Iconify icon={ICON_FROM_CLASSIFICATION[type]} sx={{ color: COLOR_FROM_CLASSIFICATION[type] }} />
            <Typography variant="caption">{count}</Typography>
        </Stack>
    )
}
